import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "src/app/core/data/service/http.service";
import { ServiceHelper } from "src/app/core/helper/services.helper";
import { Guest } from "../schema/guest";
import { UserAuction } from "../schema/user-auction";
import { AuctionService } from "./auction.service";

@Injectable({
  providedIn: 'root'
})
export class UserService extends HttpService {

  // set on load of auction so can be used in TokenInterceptor
  static communityId: number;
  
  constructor(
    http: HttpClient,
    private auctionService: AuctionService) {
    super(http);
    this.endpoint = `${this.apiURL}/users`;
  }

  fetchProfile() {
    return this.fetch(`${this.endpoint}/profile`);
  }

  async fetchUserAuctions(showArchived: boolean = false) {
    console.log('Request all auctions for user.');
    const url = `${this.apiURL}/auctions/list/${showArchived}`;
    const auctionResp = (await this.fetch(url) as UserAuction[]).map(m => new UserAuction(m));
    return auctionResp;
  }

  deleteUser() {
    return this.deleteItem(ServiceHelper.authSvc.profile.userId);
  }

  async checkIfUserCanBeDeleted() {
    return await this.fetch(`${this.endpoint}/canDelete`);
  }

  setAuctionAccess(user: Guest) {
    return this.post(user, `${this.endpoint}/access`);
  }

  setGuestTickets(user: Guest) {
    return this.post(user, `${this.endpoint}/tickets`);
  }


  archiveUserAuction(auctionId: number, archive: number) {
    return this.post(null, `${this.apiURL}/auctions/userauction/archive/${auctionId}/${archive}`);
  }

  subscribeToMailingList() {
    return this.post(null, `${this.apiURL}/mailinglist/subscribe`);
  }

  updateMailingListTag() {
    return this.post(null, `${this.apiURL}/mailinglist/updatetag`);
  }
  unSubscribeToMailingList() {
    return this.post(null, `${this.apiURL}/mailinglist/unsubscribe`);
  }

  async fetchAuctionGuests(autoCreatedOnly = false) {
    let url = `${this.endpoint}/auction/${this.auctionService.currentAuction.auctionId}`;
    if (autoCreatedOnly === true) {
      url += '/guests';
    }
    try {
      return (await this.fetch(url) as Guest[]).map(m => new Guest(m));
    } catch (error) {
      throw new Error(error);
    }
  }

  verifyUser(userId: number) {
    return this.fetch(`${this.endpoint}/auction/${this.auctionService.currentAuction.auctionId}/verify/${userId}`);
  }

  protected isUpdate(entity: Guest) {
    return (entity.userId != null);
  }

  protected getUpdateUrl(entity: Guest, endpoint: string = this.endpoint) {
    return `${endpoint}/${entity.userId}`;
  }
}
